module.exports = __webpack_public_path__ + "assets/img/IntelligentTransportation.c885f978.png";